<div class="datepicker-range" #ngbDatepicker id="ngbDatepicker" (document:mousemove)="onMouseMove()"
  (document:click)="onMouseClick($event)" (document:keydown)="isEscClose($event)">
  <ng-template #content let-modal>
    <div class="modal-header">
      <div class="select-align">
        <select class="form-control" id="dt-range-year"
          (change)="adjustDateHeader($event,true);dp.navigateTo({year: toNumber($event) , month: selectedMonth, day: 1})">
          <option [selected]="i==selected" *ngFor="let i of years">{{i}}</option>
        </select>
        <div class="arrow-down"></div>
      </div>
      <div class="redefine-align">
        <button class="redefine" id="dt-range-btn-redefine"
          (click)="redefine();dp.navigateTo({year: toNumber($event) , month: selectedMonth})">Redefinir</button>
      </div>
      <div class="selectors-div">
        <div class="calendar-div">
          <mat-icon class="calendar-icon" svgIcon="event"></mat-icon>
        </div>
        <div class="selector">
          <mat-form-field class="selector">
            <input appDatepickerMask matInput [matDatepicker]="picker1" [value]="fromDate | ngbToDate" maxlength="10"
              (blur)="newDateFrom($event); dp.navigateTo({year: this.fromDate.year , month: this.fromDate.month});">
            <mat-datepicker #picker></mat-datepicker>
            <mat-icon id="dt-range-init-date-left"
              (click)="previousDayFrom(); this.fromDate ? dp.navigateTo({year: this.fromDate.year , month: this.fromDate.month}) : false ;adjustViewWeekdays()"
              class="icon pointer" matSuffix>keyboard_arrow_left</mat-icon>
            <mat-icon id="dt-range-init-date-right"
              (click)="nextDayFrom(); this.fromDate ? dp.navigateTo({year: this.fromDate.year , month: this.fromDate.month}) : false ;adjustViewWeekdays()"
              class="icon pointer" matSuffix>keyboard_arrow_right</mat-icon>
          </mat-form-field>
        </div>
        <div class="vertical-divider"></div>
        <div class="selector">
          <mat-form-field class="selector">
            <input appDatepickerMask matInput [matDatepicker]="picker2"
              [value]="toDate ? (toDate | ngbToDate) : (null) " maxlength="10"
              (blur)="newDateTo($event); dp.navigateTo({year: this.toDate.year , month: this.toDate.month});">
            <mat-datepicker #picker></mat-datepicker>
            <mat-icon id="dt-range-end-date-left"
              (click)="previousDayTo(); this.toDate ? dp.navigateTo({year: this.toDate.year , month: this.toDate.month}) : false;adjustViewWeekdays()"
              class="icon pointer" matSuffix>keyboard_arrow_left</mat-icon>
            <mat-icon id="dt-range-end-date-right"
              (click)="nextDayTo(); this.toDate ? dp.navigateTo({year: this.toDate.year , month: this.toDate.month}) : false; adjustViewWeekdays()"
              class="icon pointer" matSuffix>keyboard_arrow_right</mat-icon>
          </mat-form-field>
        </div>
      </div>

    </div>
    <div class="horizontal-divider"></div>
    <div class="modal-body">
      <form>
        <div class="form-group">
          <div class="input-group">
            <ngb-datepicker ngbDatepicker #dp="ngbDatepicker" class="datepicker" name="dp" [(ngModel)]="model"
              [startDate]="dateIniti" [outsideDays]='"hidden"' [maxDate]="maxDate" [minDate]="minDate"
              [navigation]="'arrows'" [displayMonths]="2" [dayTemplate]="t"
              (navigate)='changeStatus($event);adjustViewWeekdays()' (dateSelect)="onDateSelection($event)">
            </ngb-datepicker>

          </div>
        </div>
      </form>
      <div class="div-buttons">
        <button style="float:right" id="dt-range-btn-cancel" class="cancel-button"
          (click)="cancelAndClose()">CANCELAR</button>
        <button style="float:right" id="dt-range-btn-confirm" class="sm" mat-raised-button color="primary02"
          (click)="confirmAndCLose()">Confirmar</button>
      </div>
    </div>
  </ng-template>
  <label (click)="open(content)">
    <mat-form-field>
      <mat-icon class="icon" matPrefix svgIcon="event"></mat-icon>
      <input [disabled]='true' matInput [value]="fromDate | ngbToDate | date: 'dd/MM/yyyy'">
      <div class="vl"></div>
    </mat-form-field>
    <mat-form-field>
      <input [disabled]='true' matInput [value]="toDate | ngbToDate | date: 'dd/MM/yyyy'">
    </mat-form-field>
  </label>
  <ng-template #t let-date="date" let-focused="focused" let-currentMonth="1">
    <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
      [class.faded]="isHovered(date) || isInside(date)" [class.maxed]="checkMax(date)" (mouseenter)="hoveredDate = date"
      (mouseleave)="hoveredDate = null">
      {{ date.day }}
    </span>
  </ng-template>
</div>
